import "clsx";
import { P as Pricing } from "../../../../chunks/Pricing.js";
import "../../../../chunks/functions.js";
import "../../../../chunks/analytics.js";
import "../../../../chunks/Animate.svelte_svelte_type_style_lang.js";
import "../../../../chunks/client.js";
function _page($$payload) {
  Pricing($$payload);
}
export {
  _page as default
};
